import { IconButton, Tooltip } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState } from "react";
import FileUploadModal from "../FileUploadModal/FileUploadModal";

interface ReuploadButtonProps {
  params: any;
  type: string;
  incident?: any;
}

const ReuploadButton = ({ params, type, incident }: ReuploadButtonProps) => {
  const [showUploadModal, setShowUploadModal] = useState(false);

  return (
    <>
      <Tooltip title="Reupload File">
        <IconButton
          color="primary"
          size="small"
          onClick={() => setShowUploadModal(true)}
          sx={{ ml: 1 }}
        >
          <CloudUploadIcon />
        </IconButton>
      </Tooltip>

      <FileUploadModal
        open={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        row={params.row}
        type={
          type as
            | "invoice"
            | "receipt"
            | "moneyRequestInvoice"
            | "moneyRequestReceipt"
            | "yardRepairInvoice"
            | "personalFolder"
            | "assetFolder"
        }
        overwriteExisting={true}
        incident={incident}
      />
    </>
  );
};

export default ReuploadButton;
